import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { LayoutSection } from '@/components/Layout/LayoutSection';
import { RaportHSPHeader } from '@/components/RaportHSP/RaportHSPHeader/RaportHSPHeader';
import { RaportHSPSummary } from '@/components/RaportHSP/RaportHSPSummary/RaportHSPSummary';
import { RaportHSPService } from '@/components/RaportHSP/RaportHSPService/RaportHSPService';
// import { RaportHSPLegal } from '@/components/RaportHSP/RaportHSPLegal/RaportHSPLegal';
import { PhotoGallery } from '@/components/PhotoGallery';
import { mockPhotos } from '@/components/PhotoGallery/mockData';
import '@/styles/raport.css';
import { mockHSPData } from '../../components/RaportHSP/RaportHSP.mock';
import { RaportHSPRecommendationsWarnings } from '@/components/RaportHSP/RaportHSPRecommendationsWarnings/RaportHSPRecommendationsWarnings';
import { RaportHSPVehicleIdentification } from '@/components/RaportHSP/RaportHSPVehicleIdentification';
import {
  HSPFinancialSpecs,
  mockFinancialSpecsData,
  RaportHSPEstimation,
  RaportHSPSpecs,
} from '@/components/RaportHSP';
import { mockRaportHSPSpecsData } from '@/components/RaportHSP/RaportHSPSpecs/RaportHSPSpecs.mock';
// import { RaportHSPTimeline } from '@/components/RaportHSP/RaportHSPTimeline';
import { RaportHSPHistory } from '@/components/RaportHSP/RaportHSPHistory';
import { InfoItem } from '@/components/Raport/RaportSummaryCard/RaportSummaryCard';
import { SectionSubtitle } from '@/components/Typography/SectionSubtitle';
import { RaportHSPLegal } from '@/components/RaportHSP/RaportHSPLegal/RaportHSPLegal';
import { VehicleParameterItem } from '@/components/Raport/RaportMainParams';

export const RaportHSP = () => {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    // Efekt dla inicjalizacji strony HSP
  }, [id]);

  const handleDownloadPdf = () => {
    console.log('Pobieranie HSP PDF...');
    // Implementacja pobierania raportu HSP PDF
  };

  const handleDownloadImages = () => {
    console.log('Pobieranie paczki zdjęć HSP...');
    // Implementacja pobierania paczki zdjęć HSP
  };

  return (
    <>
      <div className="raport-bg raport-wrapper-hsp p-4 lg:pl-[48px]">
        <RaportHSPHeader
          vehicleBrand={mockHSPData.vehicleBrand}
          vehicleModel={mockHSPData.vehicleModel}
          vinNumber={mockHSPData.vinNumber}
          orderNumber={mockHSPData.orderNumber}
          packageType={mockHSPData.packageType}
          reportDate={mockHSPData.reportDate}
          pagesCount={mockHSPData.pagesCount}
          logoUrl={mockHSPData.logoUrl}
          handleSeeGallery={() => console.log('Zobacz galerię')}
          downloadPdf={true}
          carImageUrl={'/src/assets/images/car-image.png'}
          onDownloadPdf={handleDownloadPdf}
          onDownloadImages={handleDownloadImages}
          innerStats={
            <div className="lg:gap- flex flex-1 flex-col gap-2">
              <div>
                <p className="font-inter text-base text-[#AFC4F0]">Numer VIN</p>
                <span className="font-archivo text-xl font-bold text-white">
                  XXXXXXXXXXX
                </span>
              </div>
              <div className="grid flex-1 grid-cols-1 gap-2 lg:grid-cols-2 lg:gap-6">
                <InfoItem
                  iconName="paper"
                  value={mockHSPData.orderNumber}
                  label="Numer zamówienia"
                />
              </div>
            </div>
          }
        />
      </div>

      <>
        {/* Tytuł sekcji */}
        <LayoutSection
          title=""
          description=""
          icon="apron-clothing"
          id="hsp-podsumowanie"
        >
          <RaportHSPSummary data={mockHSPData.summary} />
        </LayoutSection>

        <LayoutSection
          title="Rekomendacje i ostrzeżenia"
          id="rekomendacje-ostrzezenia"
          description="Zestawienie wykrytych problemów i weryfikacja w oparciu o stopień ryzyka zakupu."
          icon="warning"
        >
          <RaportHSPRecommendationsWarnings />
        </LayoutSection>

        {/* Dane identyfikacyjne */}
        <LayoutSection
          title="Dane identyfikacyjne"
          description="Skrót informacji identyfikacyjnych pojazdu."
          icon="i"
          id="dane-identyfikacyjne"
        >
          <RaportHSPVehicleIdentification
            data={mockHSPData.vehicleIdentification}
            onShowFullVehicleCard={() =>
              console.log('Pokazanie pełnej karty pojazdu...')
            }
          />
        </LayoutSection>

        <LayoutSection
          title="Historia szkód pojazdu"
          description="Szczegółowe parametry historii napraw i uszkodzeń."
          icon="car-accident"
          id="historia-szkod"
        >
          <RaportHSPHistory historyData={mockHSPData.history} />
        </LayoutSection>

        {/* <LayoutSection
          title="Oś czasu pojazdu"
          description="Historyczne dane dotyczące pojazdu w formie osi czasu."
          icon="fish-swimming"
        >
          <RaportHSPTimeline historyData={mockHSPData.history} />
        </LayoutSection> */}

        <LayoutSection
          title="Historia serwisowa"
          description="Informacje o wykonanych naprawach i przeglądach serwisowych"
          icon="document-task"
        >
          <RaportHSPService serviceData={mockHSPData.service} />
        </LayoutSection>
        <LayoutSection
          title="Dane techniczne"
          id="dane-techniczne"
          description="Informacje o wykonanych naprawach i przeglądach serwisowych"
          icon="car"
        >
          <RaportHSPSpecs
            data={mockRaportHSPSpecsData}
            daneIdentyfikacyjne={mockHSPData.vehicleIdentification}
          />
        </LayoutSection>

        <LayoutSection
          title="Wyposażenie pojazdu"
          description="test"
          icon="car"
          id="wyposazenie"
        >
          <div className="mt-10">
            <SectionSubtitle title="Wyposażenie pojazdu" />
            <div className="mt-11 flex flex-wrap items-center gap-5 rounded-2xl border border-solid border-violet-100 bg-white py-5">
              <VehicleParameterItem
                label="Marka i model"
                value={`${mockHSPData.vehicleBrand} ${mockHSPData.vehicleModel}`}
                fillColor="#A4B2C0"
                icon="shield"
              />
              <VehicleParameterItem
                label="Marka i model"
                value={`${mockHSPData.vehicleBrand} ${mockHSPData.vehicleModel}`}
                fillColor="#A4B2C0"
                icon="shield"
              />
              <VehicleParameterItem
                label="Marka i model"
                value={`${mockHSPData.vehicleBrand} ${mockHSPData.vehicleModel}`}
                fillColor="#A4B2C0"
                icon="shield"
              />
            </div>
            <HSPFinancialSpecs data={mockFinancialSpecsData} />
          </div>
        </LayoutSection>

        <LayoutSection
          title="Wycena wartości pojazdu"
          description="Szczegóły dotyczące wartości pojazdu oraz wszystkich elementów jego wyposażenia."
          icon="ruler-measure"
          id="wycena"
        >
          <RaportHSPEstimation
            evaluation={{
              currency: 'PLN',
              baseCarValue: 101515.76,
              depreciation: {
                rate: 79,
                value: 79837,
              },
              evaluationDate: '2025-09-23T13:12:15.196Z',
              equipmentImpact: {
                rate: 1,
                value: 211,
              },
              currentMarketValue: 21678.75,
              technicalValueAdjusted: 0,
              newCarValueWithEquipment: 117834.77,
            }}
          />
        </LayoutSection>

        <LayoutSection
          title="Status prawny"
          description="Sprawdzenie w bazach danych krajowych i międzynarodowych"
          icon="libra"
          id="status-prawny"
        >
          <RaportHSPLegal legalData={mockHSPData.legal} />
        </LayoutSection>

        <LayoutSection
          title="Galeria zdjęć"
          description="Dokumentacja fotograficzna pojazdu oraz stanu jego poszczególnych elementów"
          icon="grid-squares"
        >
          <PhotoGallery
            photos={mockPhotos}
            collapsible={false}
            galleryVariant="default"
          />
          <PhotoGallery
            galleryVariant="default"
            photos={mockPhotos}
            title="Galeria wnętrza pojazdu"
            collapsible={true}
            defaultExpanded={false}
            previewCount={4}
          />
        </LayoutSection>
      </>
    </>
  );
};

export default RaportHSP;
